import * as angular from 'angular';

import { ComponentDefinition, Pattern, Category, PropertyType } from '../../models';
import { DashboardThumbnailWidget } from '../../widgets/dashboardThumbnail/dashboardThumbnail.widget';

class DashboardSearchBarController implements angular.IComponentController {
    filtered: DashboardThumbnailWidget[];
    searchCriteria: Pattern<DashboardThumbnailWidget>[];

    readonly categories: Category[];
    readonly dashboards: DashboardThumbnailWidget[]; 

    static $inject = [];

    $onInit() {
        this.searchCriteria = [
            {
                label: 'Name',
                placeholder: 'Search pattern on the dashboard name',
                property: 'd',
                model: 'd',
                isMatch: (d, regex) => {
                    return regex.test(d.dashboard.name);
                }
            },
            {
                label: 'Group type',
                placeholder: 'Search pattern on group type',
                property: 'gt',
                model: 'gt',
                isMatch: (d, regex) => {
                    return (d.dashboard.groupTypes.filter(gt => regex.test(gt)).length > 0) || (!d.dashboard.groupTypes.length && regex.test(''));
                }
            },
            {
                label: 'Category',
                placeholder: 'Search pattern on the dashboard category',
                property: 'cat',
                model: 'cat',
                isMatch: (d, regex) => {
                    const categories = this.categories.filter(c => regex.test(c.name))
                        .map(c => c.guid);
                    return !!d.categories.filter(c => categories.indexOf(c) >= 0).length || (!d.categories.length && regex.test(''));
                }
            },
            {
                label: 'Use legacy print system',
                placeholder: 'Search pattern on legacy print system',
                property: 'ulp',
                model: 'ulp',
                type: PropertyType.Boolean,
                isMatch: (d, regex) => {
                    return regex.test((!d.dashboard.configuration.printConfiguration.isUseNewPrintSystem)?.toString());
                }
            }
        ];
    }
}

export const wtDashboardSearchBar: ComponentDefinition = {
    componentId: 'wtDashboardSearchBar',
    controller: DashboardSearchBarController,
    template: require('./dashboardSearchBar.component.html'),
    controllerAs: 'vm',
    bindings: {
        dashboards: '<',
        filtered: '=',
        categories: '<'
    }
};
